import React from 'react';
import LazyLoad from 'react-lazyload';

// Importing components
import ContactArea from './services-component/ContactArea';
import ServicesCounter from './services-component/ServicesCounter';
import Enterprise_Seo from './services-component/Enterprise_Seo';
import Seo_Process from './services-component/Seo_Process';
import Seo_marketing_ser from './services-component/Seo_marketing_ser';
import Faq_s from './services-component/Faq-seo';
import Top_heading from './component/Top_heading';
import { Helmet } from 'react-helmet-async';

export default function SEO_Services() {
  return (
    <>
      <Helmet>
  {/* ✅ Meta Title */}
  <title>
    Best SEO Services in Dubai & India | RajDigi SEO Company
  </title>

  {/* ✅ Meta Description */}
  <meta
    name="description"
    content="Leading SEO company in UAE & India. Get proven SEO services in Dubai & across India. Drive organic traffic, rankings & ROI with RajDigi's expert team."
  />

  {/* ✅ Meta Keywords */}
  <meta
    name="keywords"
    content="SEO services, SEO company UAE, SEO services India"
  />
</Helmet>
 
      {/* SECTION1 */}
      <LazyLoad height={200} offset={100} placeholder={<div>Loading...</div>}>
        <Top_heading Heading="Want to Improve Your Search Rankings?" para="If you're looking to grow your visibility and attract the right audience, our SEO strategies are designed to deliver long-term results based on your business goals." />
      </LazyLoad>

      <LazyLoad height={200} offset={100} placeholder={<div>Loading...</div>}>
        <Enterprise_Seo />
      </LazyLoad>

      <LazyLoad height={200} offset={100} placeholder={<div>Loading...</div>}>
        <ServicesCounter />
      </LazyLoad>
{/* 
      <LazyLoad height={200} offset={100} placeholder={<div>Loading...</div>}>
        <Seo_Process />
      </LazyLoad> */}

      <LazyLoad height={200} offset={100} placeholder={<div>Loading...</div>}>
        <Seo_marketing_ser />
      </LazyLoad>

      <LazyLoad height={200} offset={100} placeholder={<div>Loading...</div>}>
        <Faq_s />
      </LazyLoad>

      <LazyLoad height={200} offset={100} placeholder={<div>Loading...</div>}>
        <ContactArea />
      </LazyLoad>
    </>
  );
}
